import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=46543cee&scoped=true&"
import script from "./Distribution.vue?vue&type=script&lang=js&"
export * from "./Distribution.vue?vue&type=script&lang=js&"
import style0 from "./Distribution.vue?vue&type=style&index=0&id=46543cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46543cee",
  null
  
)

export default component.exports